<template>
	<div id="page-user-edit">
		<bread-crumbs
			:title="$t('StatusModule.StatusLink')"
			:subTitle="$t('general.SubtitleStatus')"
			:sizeTitle="30"
			:lineHeightTitle="37"
			:sizeSubTitle="15"
			:lineHeightSubTitle="18"
		>
		</bread-crumbs>
		<div class="vx-card p-4">
			<div class="tab-text">
				<status-child :createStatus="createStatus"></status-child>
			</div>
		</div>
	</div>
</template>

<script>
import StatusChild from "./StatusChild.vue";

export default {
	components: {
		StatusChild,
	},
	data() {
		return {
			createStatus: false,
		};
	},
};
</script>
